module.exports = __webpack_public_path__ + "static/media/Geo Stream.cbad1c93.jpg";